module.exports = __webpack_public_path__ + "img/act2_img_jindu@2x.1be3f8ef.png";